import { useContext } from 'react';
import MetricsInspectionContext from '../../state/context';
import usePeriods from '../../state/hooks/usePeriods';

const useFilters = () => {
  const {
    state: {
      filters: { team, contributor, repo = [], service = [], label },
      granularity
    }
  } = useContext(MetricsInspectionContext);

  const { lastPeriod } = usePeriods();

  const filters = {
    selectedGranularity: granularity,
    selectedTimeRanges: {
      start_date: lastPeriod.after,
      end_date: lastPeriod.before
    },
    ...(team ? { globallySelectedTeams: [team] } : {}),
    ...(contributor ? { selectedContributor: contributor } : {}),
    ...(repo.length ? { selectedRepo: repo.map(({ id }) => id) } : {}),
    ...(label ? { selectedLabels: [label] } : {}),
    ...(service.length ? { selectedService: service.map(({ id }) => id) } : {})
  };
  return filters;
};

export default useFilters;
